import React from 'react';
import { Box } from 'glints-aries';

import { Paragraph } from '../Paragraph';
import * as S from './styles.sc';

type Props = {
  title: React.ReactNode;
  list: React.ReactNode[];
};

export const ListWithTitle: React.FC<React.PropsWithChildren<Props>> = ({
  title,
  list,
}) => {
  return (
    <Box mb={24}>
      <Paragraph>{title}</Paragraph>
      <S.List>
        {list.map((item, index) => {
          return <li key={index}>{item}</li>;
        })}
      </S.List>
    </Box>
  );
};
